import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import ProfileMenu from "./partial/ProfileMenu";
import { QUERY } from "../../queries/patient.query";
import { GET_TYPES } from "../../queries/assessment.query";
import "./partial/Profile.css";
import LoadingSpinner from "../../partials/loading";
import PatientProfileCard from "./partial/PatientProfileCard";
import auth from "../../providers/Auth.Provider";
import { Route, Switch } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import CorrespondenceIndex from "./Profile/Correspondence";
import Timetable from "./Profile/Timetable";
import { SaveData } from "../../providers/Patient.Provider";
import Leave from "./Profile/Leave";
import RoomSearch from "./Profile/RoomSearch";
import DrugChart from "./Profile/DrugChart";
import HealthBlood from "./Profile/HealthBlood";
import GlucoseMonitoring from "./Profile/GlucoseMonitoring";
import FoodIntake from "./Profile/FoodFluid";
import FluidIntake from "./Profile/Fluid";
import CarePlan from "./Profile/Careplan";
import Allergy from "./Allergy";
import NextOfKin from "./NextOfKin";
import Assessment from "./Profile/Assessment";
import PatientRisk from "./Profile/Risk";
import HealthObservation from "./Profile/HealthObservation";
import BMITool from "./Profile/BMI-Tool";
import PatientVitals from "./Profile/Vitals";
import PatientActivity from "./Profile/Activity";
import BodyMap from "./Profile/BodyMap";
import PatientPlanNote from "./Profile/Note";
import AdmitPatient from "./Admit";
import PatientSummary from "./Profile/PatientSummary.jsx";
import PatientPersonalDoctor from "./PersonalDoctor.jsx";
import PatientPersonalNurse from "./PrimaryNurse.jsx";
import PatientPsychiatrist from "./PatientPsychiatrist.jsx";
import EmergencyContact from "./Profile/EmergencyContact.jsx";
import ShortTermAssessment from "./Profile/ShortTermAssessment";
import InterestCheckList from "./Profile/InterestCheckList";
import PersonalAssessment from "./Profile/personal-assessment";
import RiskMatrix from "./Profile/RiskMatrix";
import WaterFlowPressure from "./Profile/Waterflow-Ucler";
import EditPatient from "./Edit";
import PatientDischarge from "./Profile/Discharge";
import QRCodePage from "../QRCode";
import Image from "../../partials/Image";
import dummy from "../../img/image.png";

const PatientProfile = ({ match, location }) => {
    const { id } = match.params;
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const [patient, setPatient] = useState({});
    const { site } = GetToken() && GetAuthenticatedStaff();
    const { loading, data, error } = useQuery(QUERY.GETPATIENT, {
        variables: { id },
        onCompleted: (data) => {
            SaveData(data.GetPatient.doc);
            const { id, name } = data.GetPatient.doc;
            localStorage.setItem("_active", JSON.stringify({ id, name }));
            setPatient(data.GetPatient.doc);
        },
    });
    const { loading: aLoading, data: aData } = useQuery(GET_TYPES, {
        variables: { site: site && site.id },
    });

    const title = "Patient Profile";

    // Check if the ref props
    if (!id)
        return (
            <Redirect
                to={{
                    pathname: "/home/clinical-note/find-patient",
                    search: `?redirect=${location.pathname}`,
                }}
            />
        );
    if (error && auth.authProvider.IsAuthenticationError(error.message)) {
        // clear session
        auth.authProvider.LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${location.pathname}`,
                }}
            />
        );
    }
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <div className="row justify-content-center">
                {/* Profile */}
                <div className="col-md-3">
                    <div className="row">
                        <div className="col-12">
                            {data && (
                                <div className="card fade-in">
                                    <div className="card-body p-5" style={{ borderRadius: "12px" }}>
                                        <center>
                                            <Image width={120} height={120} alt={data.GetPatient.doc.name} src={data.GetPatient.doc.profile_picture || dummy} />
                                            <br />
                                            <strong style={{ fontSize: "2em", fontWeight: "lighter", color: "#00a65a" }}>{data.GetPatient.doc.name}</strong> <br />
                                        </center>
                                    </div>
                                </div>
                            )}
                            <div className="card">
                                <div className="card-body height-9">
                                    <LoadingSpinner loading={loading || aLoading} bar={true} />
                                    <PatientProfileCard patient={data && data.GetPatient.doc} />
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <QRCodePage match={match} />
                        </div>
                    </div>
                </div>
                {/* Content */}
                <div className="col-md-9">
                    <div className="row">
                        {/* Navigation */}
                        <div className="col-12 mb-1">
                            <ProfileMenu match={match} location={location} admitted={patient.admitted} assessments={aData && aData.GetAssessments.docs} />
                        </div>
                        {/* Body */}
                        <div className="col-md-12">
                            <Switch>
                                <Route path={`${match.path}/attachment`} component={CorrespondenceIndex} />
                                <Route path={`${match.path}/leave`} component={Leave} />
                                <Route path={`${match.path}/room-search`} component={RoomSearch} />
                                <Route path={`${match.path}/drug-chart`} component={DrugChart} />
                                <Route path={`${match.path}/health-blood`} component={HealthBlood} />
                                <Route path={`${match.path}/glucose-monitoring`} component={GlucoseMonitoring} />
                                <Route path={`${match.path}/food-fluid`} component={FoodIntake} />
                                <Route path={`${match.path}/allergy`} component={Allergy} />
                                <Route path={`${match.path}/fluid-intake`} component={FluidIntake} />
                                <Route path={`${match.path}/care-plan`} component={CarePlan} />
                                <Route path={`${match.path}/health-observation`} component={HealthObservation} />
                                <Route path={`${match.path}/ibm-tool`} component={BMITool} />
                                <Route path={`${match.path}/vital`} component={PatientVitals} />
                                <Route exact path={`${match.path}/activity`} component={PatientActivity} />
                                <Route path={`${match.path}/timetable`} component={Timetable} />
                                <Route path={`${match.path}/body-map`} component={BodyMap} />
                                <Route path={`${match.path}/next-kin`} component={NextOfKin} />
                                <Route path={`${match.path}/risk`} component={PatientRisk} />
                                <Route path={`${match.path}/care-note`} component={PatientPlanNote} />
                                <Route path={`${match.path}/assessment/:id`} component={Assessment} />
                                <Route path={`${match.path}/add-next-of-kin`} component={NextOfKin} />
                                <Route path={`${match.path}/update-allergy`} component={Allergy} />
                                <Route path={`${match.path}/update-doctor`} component={PatientPersonalDoctor} />
                                <Route path={`${match.path}/update-nurse`} component={PatientPersonalNurse} />
                                <Route path={`${match.path}/update-psychiatrist`} component={PatientPsychiatrist} />
                                <Route path={`${match.path}/update-emergency`} component={EmergencyContact} />
                                <Route path={`${match.path}/short-service-assessment`} component={ShortTermAssessment} />
                                <Route path={`${match.path}/interest-checklist`} component={InterestCheckList} />
                                <Route path={`${match.path}/personal-assessment`} component={PersonalAssessment} />
                                <Route path={`${match.path}/risk-matrix`} component={RiskMatrix} />
                                <Route path={`${match.path}/water-flow-assessment`} component={WaterFlowPressure} />
                                <Route path={`${match.path}/update-patient`} component={EditPatient} />
                                <Route path={`${match.path}/admit-patient`} component={AdmitPatient} />
                                <Route path={`${match.path}/discharge-patient`} component={PatientDischarge} />
                                <Route path={match.path} component={PatientSummary} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PatientProfile;
